import { z } from 'zod'

import {
  nameField,
  phoneNumberField,
} from '@maestro/commerce-blocks/schemas/fields'
import { optionalNonEmptyField } from '@maestro/commerce-blocks/schemas/helpers'

export const returnComplaintFormSchema = z.object({
  contactName: optionalNonEmptyField(nameField('first-name')),
  contactPhone: optionalNonEmptyField(phoneNumberField),
})
